import PortalDatePicker from 'components/PortalDatePicker';

export default function ReportDateRange({ id, fromDate, toDate, setFromDate, setToDate }) {
    return <div className="portal-report-dates">
        <label htmlFor={`${id}-from`}>From date<PortalDatePicker inputId={`${id}-from`} label="From date" value={fromDate} maxDate={toDate} onChange={(event) => setFromDate(event.value)} /></label>
        <label htmlFor={`${id}-to`}>To date<PortalDatePicker inputId={`${id}-to`} label="To date" value={toDate} minDate={fromDate} onChange={(event) => setToDate(event.value)} /></label>
        {(fromDate || toDate) && <button type="button" className="portal-date-reset" onClick={() => { setFromDate(null); setToDate(null); }}>Reset</button>}
    </div>;
}
